import storageService from './storage'

const ADVANCED_SEARCH_STATUS_KEY = 'searches_status:advanced_search'

export default {
  saveFilters: (filters) => {
    storageService.writeAndMerge(ADVANCED_SEARCH_STATUS_KEY, { ...filters })
  },

  read: () => storageService.read(ADVANCED_SEARCH_STATUS_KEY),

  clear: () => storageService.clear(ADVANCED_SEARCH_STATUS_KEY),

  expiresIn: () => storageService.expiresIn(ADVANCED_SEARCH_STATUS_KEY)
}
